export enum StorageK {
	Fields = 'fields',
	Progress = 'progress',
	ProjectId = 'sso.app.projectId',
	TenantId = 'sso.app.tenantId',
	SsoId = 'sso.app.ssoId',
	CookieName = 'sso.app.cookieName'
}

export const DEFAULT_SSO_ID = 'default_ssoid';

export enum QueryParamK {
	Token = 't',
	TenantId = 'tenantId',
	SsoId = 'ssoId',
	CookieName = 'cookieName',
	Theme = 'theme',
	Target = 'target'
}
